import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import StudentDashboard from "./student/StudentDashboard";
import ExaminerDashboard from "./examiner/ExaminerDashboard";
import AdminDashboard from "./admin/AdminDashboard";
import ProctorDashboard from "./proctor/ProctorDashboard";

function fireWelcomeConfetti() {
  const defaults = { startVelocity: 25, spread: 360, ticks: 60, zIndex: 9999, scalar: 0.9 };
  const duration = 1500;
  const end = Date.now() + duration;
  const colors = ["#f59e0b", "#10b981", "#3b82f6", "#ef4444", "#8b5cf6"];
  (function frame() {
    confetti({ ...defaults, particleCount: 4, origin: { x: Math.random() * 0.3, y: Math.random() - 0.2 }, colors });
    confetti({ ...defaults, particleCount: 4, origin: { x: 0.7 + Math.random() * 0.3, y: Math.random() - 0.2 }, colors });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export default function Dashboard() {
  const { user } = useAuth();

  useEffect(() => {
    try {
      const flag = localStorage.getItem("examos_welcome_bonus");
      if (flag === "1" && user) {
        localStorage.removeItem("examos_welcome_bonus");
        // Give the UI a beat to settle before confetti to avoid competing with
        // navigation transitions.
        setTimeout(() => {
          fireWelcomeConfetti();
          toast.success(
            `🎉 Welcome ${user.name?.split(" ")[0] || "there"}! ${user.credits || 500} credits added to your wallet.`,
            { duration: 6000 },
          );
        }, 350);
      }
    } catch { /* no-op */ }
  }, [user]);

  if (!user) return null;
  switch (user.role) {
    case "student": return <StudentDashboard />;
    case "examiner": return <ExaminerDashboard />;
    case "institution_admin": return <AdminDashboard />;
    case "super_admin": return <AdminDashboard />;
    case "proctor": return <ProctorDashboard />;
    default: return <StudentDashboard />;
  }
}
